/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a Tenant OIDC configuration object as returned by the API
 * @export
 * @interface OidcConfig
 */
export interface OidcConfig {
    /**
     * The provider name, e.g. 'microsoft' or 'google'
     * @type {string}
     * @memberof OidcConfig
     */
    providerName: string;
    /**
     * Authority/issuer URL, e.g. 'https://login.microsoftonline.com/<tenant>/v2.0'
     * @type {string}
     * @memberof OidcConfig
     */
    authorityUrl: string;
    /**
     * Client ID for this OIDC application
     * @type {string}
     * @memberof OidcConfig
     */
    clientId: string;
    /**
     * Scopes requested from the OIDC provider
     * @type {string}
     * @memberof OidcConfig
     */
    scope?: string | null;
}

/**
 * Check if a given object implements the OidcConfig interface.
 */
export function instanceOfOidcConfig(value: object): value is OidcConfig {
    if (!('providerName' in value) || value['providerName'] === undefined) return false;
    if (!('authorityUrl' in value) || value['authorityUrl'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function OidcConfigFromJSON(json: any): OidcConfig {
    return OidcConfigFromJSONTyped(json, false);
}

export function OidcConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): OidcConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'providerName': json['provider_name'],
        'authorityUrl': json['authority_url'],
        'clientId': json['client_id'],
        'scope': json['scope'] == null ? undefined : json['scope'],
    };
}

export function OidcConfigToJSON(json: any): OidcConfig {
    return OidcConfigToJSONTyped(json, false);
}

export function OidcConfigToJSONTyped(value?: OidcConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider_name': value['providerName'],
        'authority_url': value['authorityUrl'],
        'client_id': value['clientId'],
        'scope': value['scope'],
    };
}

